module.exports = __webpack_public_path__ + "img/menuDetail5.61424cc5.png";